// extracted by mini-css-extract-plugin
export default {"column-container":"CreateModuleNormalTab_column-container__SuoNx"};